import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid, Slider, CircularProgress, IconButton, Box } from '@material-ui/core';
import Container from '../../components/Container'
import Typo from '../../components/CustomTypo';
import { portalCfg, navigate } from '../../../portal.router.config' //config/routes'
import { WalletIcon, UnitIcon, DeliveryIcon, PickUpIcon, BarcodeScanIcon, WaveHandIcon, HelloOrderIcon, ShoppingCartIcon, CartHomeIcon, OrdersHomeIcon, MyAccountIcon } from '../../components/icons'
import classNames from 'classnames';
import OfferItem from '../offers/OfferItem';
import ProgressBar from '../../components/ProgressBar';
import CustomizedCircularProgress from '../../components/CircularProgress'
import defaultTheme from '../../theme.css';
import { pageConfig } from '../../../portal.menu.config';
import InfiniteScroll from 'react-infinite-scroll-component';
import { getAppCfg, getContacts, getSupportOrder } from '../../utils/common';
import ButtonCustom from '../../components/ButtonCustom';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import {creatives_usage_types} from '../../wsclient/crmservices/dataUtil';
import SubcriptionItem from '../subcriptions/SubcriptionItem';
import { domainName } from '../../../portal.config';
const cupIcon = portalCfg.publicPath + "/assets/images/cup.png"
const heightCoverItem = 200

var levelImages = [
    portalCfg.publicPath + '/assets/images/cup/cup_empty.png',
    portalCfg.publicPath + '/assets/images/cup/kubek_costa_1.png',
    portalCfg.publicPath + '/assets/images/cup/kubek_costa_1.png',
    portalCfg.publicPath + '/assets/images/cup/kubek_costa_2.png',
    portalCfg.publicPath + '/assets/images/cup/kubek_costa_3.png',
    portalCfg.publicPath + '/assets/images/cup/kubek_costa_4.png',
    portalCfg.publicPath + '/assets/images/cup/kubek_costa_5.png',
    portalCfg.publicPath + '/assets/images/cup/kubek_costa_6.png',
    portalCfg.publicPath + '/assets/images/cup/kubek_costa_7.png',
    portalCfg.publicPath + '/assets/images/cup/kubek_costa_8.png',
    portalCfg.publicPath + '/assets/images/cup/kubek_costa_9.png'
]

const styles = theme => ({
    card: {
        padding: theme.spacing(3),
        position: 'relative',
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(0, 3, 0, 3),
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(0, 3, 0, 3),
        },
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(0, 2, 0, 2),
        },
    },
    cardContent: {
        //height: 180,
        backgroundColor: theme.palette.background.card,
        borderRadius: theme.shape.borderRadius2x,
        padding: theme.spacing(5),
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(2),
        zIndex: 1,
        [theme.breakpoints.down('xs')]: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
        },
    },
    cardOrder: {
        padding: theme.spacing(3),
        position: 'relative',
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(0, 3, 0, 3),
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(0, 3, 0, 3),
        },
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(0, 2, 0, 2),
        },
        cursor: 'pointer',
    },
    button_order: {
        marginTop: theme.spacing(2),
        cursor: 'pointer',
        backgroundColor: theme.palette.button.primary.backgroundColor,
        borderRadius: theme.spacing(10),
    },
    cursor: {
        cursor: 'pointer',
    },
    handIcon: {
        height: 35,
    },

    // row1: {
    //     height: 40
    // },
    bg_icon: {
        height: theme.spacing(6),
        width: theme.spacing(6),
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(1),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    barcode: {
        height: '10%',
        top: theme.spacing(8),
        right: theme.spacing(5),
        zIndex: 999,
        position: 'absolute',
        [theme.breakpoints.down('xs')]: {
            top: theme.spacing(5),
        },
    },
    orderBox: {
        padding: theme.spacing(4),
        border: '1px solid',
        borderColor: theme.palette.background.transparent,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
    },
    orderItem: {
        padding: theme.spacing(6, 4, 4, 4),
        border: '1px solid',
        borderColor: theme.palette.background.transparent,
        backgroundColor: theme.palette.background.other,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        position: 'relative',

    },
    circle: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        borderRadius: theme.spacing(5),
        boxShadow: ' -1px 2px 14px -5px rgba(0,0,0,0.75)',
        border: '1px solid',
        borderColor: theme.palette.background.transparent,
        backgroundColor: theme.palette.background.primary,
        position: 'absolute',
        top: -theme.spacing(5),
        left: theme.spacing(10),
        textAlign: 'center',
    },
    tier_circle: {
        width: 60,
        height: 60,
        borderRadius: 10,
        // backgroundColor: theme.palette.background.secondary,
        overflow: 'hidden',
        justifyContent: 'flex-end',
        margin: theme.spacing(2, 4, 0, 0)
    },
    cup: {
        position: 'absolute',
        top: theme.spacing(7),
        right: theme.spacing(5),
        [theme.breakpoints.down('xs')]: {
            top: theme.spacing(3),
            right: theme.spacing(1),
        },
    },
    cup_1: {
        position: 'absolute',
        top: theme.spacing(7),
        right: theme.spacing(5),
        [theme.breakpoints.down('xs')]: {
            top: theme.spacing(3),
            right: theme.spacing(1),
        },
    },
    item: {
        border: '0px solid',
        borderColor: theme.palette.background.transparent,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        cursor: 'pointer',
        position: 'relative',
        marginTop: theme.spacing(2)
    },
    item_cover: {
        width: '100%',
        height: 250,
        objectFit: 'cover',
        borderRadius: theme.spacing(4),
    },
    item_content: {
        padding: theme.spacing(4),
        background: 'rgba(255,255,255,0.5)',
        borderBottomLeftRadius: theme.spacing(4),
        borderBottomRightRadius: theme.spacing(4),
        height: 80,
        width: '100%',
        position: 'absolute',
        bottom: 0
    },
    account_number:{
        marginTop: theme.spacing(2)
    }
});

function HomeView(props) {
    const onOpenOrder = () => {

    }

    const { classes, t, reward_tiering, offers, addresses, onShowAllotment, contactName, onShowOfferDetail, tier_progress, showLoading, handleLoadMore, hasMore, showLoadMore, subscriptions } = props;
    // console.log("subscriptions===", subscriptions);
    var current_tier = tier_progress.current_tier;
    var next_tier = tier_progress.next_tier;
    const app_config = getAppCfg();

    const showExploreMore = app_config && app_config.features && app_config.features.marketing_content ? app_config.features.marketing_content : false;
    const embedded_links = app_config && app_config.features && app_config.features.marketing_content_details && app_config.features.marketing_content_details.embedded_links ? app_config.features.marketing_content_details.embedded_links : []   
    return (
        <Container>
            <Grid xs={12} item>
                <Grid xs={12} item>
                    <Grid xs={12} item container className={classes.card}>
                        <Typo variant='h2' color='onPrimary'>{t('landing_welcome')}&nbsp;{contactName}&nbsp;</Typo>
                        <WaveHandIcon className={classes.handIcon} />
                    </Grid>
                    <Grid xs={12} item container direction="row">
                        <AccountBalance
                            classes={classes}
                            t={t}
                            currency={props.currency}
                            accountBalance={props.accountBalance}
                        />
                        {props.isShowOffer && <WalletBalance tier_progress={tier_progress} classes={classes} t={t} onShowBarcode={props.onShowBarcode} wallet={props.wallet} currency={props.currency} onShowAllotment={onShowAllotment} walletContact={props.walletContact} />}
                        {reward_tiering && <MyUnits classes={classes} t={t} rewards={props.rewards} tier_progress={tier_progress} />}
                        {getSupportOrder() && <OrderCard classes={classes} t={t} onClick={onOpenOrder} />}
                    </Grid>
                    {/* <Grid>
                        <ButtonCustom color='onPrimary' onClick={props.onShowServiceRequests}>{'Service Requests'}</ButtonCustom>
                    </Grid> */}
                </Grid>
                {showExploreMore && <ExploreMore classes={classes} t={t}
                    embedded_links={embedded_links} />}
                {props.isShowOffer&&<Offers classes={classes} t={t} 
                    offers={offers} 
                    onShowOfferDetail={onShowOfferDetail} 
                    showLoading={showLoading}
                    handleLoadMore={handleLoadMore}
                    hasMore={hasMore}
                    showLoadMore = {showLoadMore}/>}
                {domainName == 'airlink' && <Subscriptions
                    t={t}
                    classes={classes}
                    subscriptions={subscriptions}
                    showLoading={showLoading}
                    handleLoadMore={props.handleLoadMoreServices}
                    hasMore={hasMore}
                    showLoadMore={showLoadMore}
                    subscriptionsFilter={props.subscriptionsFilter}
                    currency={props.currency}
                    periods={props.periods}
                    periodSelected={props.periodSelected}
                    onChangeTab={props.onChangeTab}
                />}
            </Grid>
            {/* {props.showBarcode && <Barcode onClose={props.onShowBarcode} open={props.showBarcode} value={props.authentication_code} />} */}
        </Container>
    );
}

function Order(props) {
    const { classes, t } = props
    var addresses = props.addresses;
    var contactAdd = t('no_address');

    if (addresses && addresses.length > 0) {
        var address = addresses.filter(add => {
            if (add.is_primary) {
                return add;
            }
        })
        if (address.length > 0) {
            contactAdd = address[0].address_line_1
        }
    }
    return (
        <Grid xs={12} item className={classes.orderBox} >
            <Typo variant='h3' color='tertiary' >{t('order_online')}</Typo>
            <Grid item container xs={12} direction="row">
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <Grid className={classes.orderItem}>
                        <Grid xs={12} item>
                            <Typo variant='h5' >{t('delivery')}</Typo>
                        </Grid>
                        <Grid xs={12} item>
                            <Typo mg_top_xs variant='body1' color='secondary' >{contactAdd}</Typo>
                        </Grid>
                        <Grid xs={12} item container justify='center'>
                            <Grid className={classes.circle} item container alignItems='center' justify='center'>
                                <DeliveryIcon />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <Grid elevation={3} className={classes.orderItem}>
                        <Grid xs={12} item>
                            <Typo variant='h5' >{t('pickup')}</Typo>
                        </Grid>
                        <Grid xs={12} item className={classes.marginTop}>
                            <Typo variant='body1' color='secondary' >{contactAdd}</Typo>
                        </Grid>
                        <Grid className={classes.circle} item container alignItems='center' justify='center'>
                            <PickUpIcon />
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </Grid>
    )
}

function Offers(props) {
    const { classes, t, offers, onShowOfferDetail, hasMore, handleLoadMore, showLoading, showLoadMore } = props;
    //console.log('HomeView hasMore=', hasMore)
    //const OffersMap = Array.from(offers)
    return (
        <Grid item>
            <Typo mg_left_md variant='caption1' color='onPrimary'>{t('recommended_offers')}</Typo>
            {showLoading && <Grid xs={12} item container justify='center'>
                <CustomizedCircularProgress />
            </Grid>}
            <Grid xs={12} item>
                <InfiniteScroll
                    dataLength={offers.length} //This is important field to render the next data
                    next={handleLoadMore}
                    hasMore={hasMore}
                    loader={showLoadMore ? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                >
                    <Grid xs={12} item container className={classes.margin}>
                        {offers.map((item, index) => (
                            <OfferItem key={index} item={item} onShowOfferDetail={onShowOfferDetail} />
                        ))}
                    </Grid>
                </InfiniteScroll>
            </Grid>
        </Grid>
    )
}

function OrderCard(props) {
    const { classes, t } = props;
    return (
        <Grid item xs={12} sm={12} md={12} lg={4} xl={4} container className={classes.cardOrder} onClick={() => navigate(pageConfig[2].route)}>
            <Grid xs={12} item container className={classNames(classes.cardContent)} justify='center'>
                <div style={{ width: 100, height: 100, borderRadius: 100, backgroundColor: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}>
                    <OrdersHomeIcon />
                </div>
                <Grid xs={12} item container justify='center'>
                    <Grid xs={8} item container className={classes.button_order} justify='center' alignItems='center' >
                        <Typo mg_left_xs mg_top_xs color='onPrimary' variant='subtitle2'>{t('place_an_order')}</Typo>
                    </Grid>
                </Grid>

            </Grid>
        </Grid>
    )
}

function MyUnits(props) {
    const { classes, t, rewards, tier_progress } = props;
    console.log('MyUnits tier_progress==', tier_progress)
    var str = t('you_have') + tier_progress.period_value_units + t('units') + " " + t('target_unit') + tier_progress.points_needed + t('target_unit_2') + tier_progress.collected_by;
    if (tier_progress.isProgress) {
        str += t('target_unit_3') + tier_progress.remain_name;
    } else {
        str += t('target_unit_3_b') + tier_progress.remain_name;
    }
    str = str + t('target_unit_4');
    const app_config_creatives = getAppCfg().creatives ? getAppCfg().creatives : null;
    console.log("tier_progress: ", tier_progress);
    //app_config_creatives[1].usage_type = "WALLET_IMAGE"
    var tier_image = tier_progress && tier_progress.tier_image ? tier_progress.tier_image : dataUtil.getImageByUsageTypePortal(app_config_creatives, usage_type.wallet_image, true);

    console.log('tier_image: ', tier_image);
    var urlTier_Image = tier_image && tier_image.url ? tier_image.url : null;
    var css_tier_image = {
        backgroundImage: 'url(' + urlTier_Image + ')',
        background: '-webkit-image-set( url(' + urlTier_Image + ') 1x, url(' + urlTier_Image + ') 2x )',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
    }

    return (
        <Grid item xs={12} sm={12} md={12} lg={4} xl={4} container className={classes.card}>
            <Grid item container className={classes.cardContent}>
                <Grid xs={12} item container direction="row" >
                    <Grid item xs={9}>
                        <Grid xs={12} item container className={classes.row1}>
                            <Grid xs={1} item container alignItems='center'>
                                <Grid className={classes.bg_icon}>
                                    <UnitIcon />
                                </Grid>
                            </Grid>

                            <Grid item xs={11} container alignItems='center'>
                                <Typo variant='h6' color='onPrimary'>{t('reward_tier')}</Typo>
                            </Grid>

                        </Grid>
                        <Grid xs={12} item>
                            {rewards && rewards.reward_tier ? <Typo variant='h1' mg_top_xs color="onPrimary">{tier_progress.current_name}</Typo> : <CustomizedCircularProgress />}
                        </Grid>
                    </Grid>
                    <Grid xs={3} item container justify='flex-end'>
                        <Grid item className={classes.tier_circle} style={css_tier_image}>
                            {/* <Grid style={{ height: (100-tier_progress.percentage) + "%", backgroundColor: defaultTheme.palette.background.secondary, opacity: 0.8 }} /> */}
                        </Grid>

                    </Grid>
                    {/* {rewards && rewards.reward_tier && <CofferCup percentage={tier_progress.percentage} classes={classes}/>} */}
                </Grid>

                {tier_progress.current_name && <Grid container item xs={12}>
                    <Typo mg_top_xl variant='body1' color='onPrimary'>{str}</Typo>
                </Grid>}
            </Grid>
        </Grid>
    );
}

function WalletBalance(props) {
    const { classes, t, wallet, onShowAllotment, tier_progress, walletContact } = props;
    var balance = wallet && wallet.balance ? wallet.balance : 0;
    var specialCondition = wallet && wallet.commerce_balance ? wallet.commerce_balance : 0
    var anyCondition = wallet && wallet.open_balance ? wallet.open_balance : 0
    var progressAny = anyCondition && balance ? anyCondition * 100 / balance : 0;
    
    if (walletContact && walletContact.balances) {
        var crmWallet = walletContact.balances.find(walletContact => walletContact.type === "CRM");
        var crmTotal = crmWallet ? crmWallet.total : 0.00;
        var businessWallet = walletContact.balances.find(walletContact => walletContact.type === "BUSINESS");
        var businessOpen = businessWallet ? businessWallet.open : 0.00;
        var businessCommerce = businessWallet ? businessWallet.commerce : 0.00;
        var totalBalance = crmTotal + businessOpen;
    }
    return (
        <Grid item xs={12} sm={12} md={12} lg={4} xl={4} container className={classes.card} >
            <Grid item container className={classNames(classes.cardContent, classes.cursor)} onClick={onShowAllotment}>
                <Grid xs={12} item  >
                    <Grid item xs={12}>
                        <Grid xs={12} item container className={classes.row1}>
                            <Grid xs={1} item container alignItems='center'>
                                <Grid className={classes.bg_icon}>
                                    <WalletIcon />
                                </Grid>
                            </Grid>
                            <Grid item xs={11} container alignItems='center'>
                                <Typo variant='h6' color='onPrimary'>{t('my_wallet')}</Typo>
                            </Grid>
                        </Grid>
                        <Grid xs={12} item>
                            {wallet && (wallet.balance != null || wallet.balance != undefined) ? <Typo variant='h1' mg_top_xs color='onPrimary'>{props.currency}{wallet.balance ? wallet.balance.toFixed(2) : '0.00'}</Typo> : <CustomizedCircularProgress />}
                        </Grid>
                    </Grid>
                    {/* <Grid xs={3} item   containerjustify='flex-end'> */}
                    {/* <LinkCTA  className={classes.barcode}  onClick={() => props.onShowBarcode()} color="primary"><BarcodeScanIcon /></LinkCTA> */}
                    {/* </Grid> */}
                </Grid>
                {/* <Grid xs={12} item container>
                    <Typo variant='subtitle1' mg_top_xl color='onPrimary' onClick={onShowAllotment}>{t('spend_condition') + " >"}</Typo>
                </Grid> */}
                <Grid xs={12} item >
                    <ProgressBar completed={progressAny} />
                </Grid>
                <Grid item container xs={12}>
                    <Grid item xs={6}>
                        <Typo variant='body1' color='onPrimary'>{t('any_where')}</Typo>
                        {walletContact && walletContact.balances ? <Typo variant='body1' color='onPrimary'>{props.currency}{totalBalance.toFixed(2)}</Typo> : <CustomizedCircularProgress />}
                    </Grid>
                    <Grid item xs={5}>
                        <Typo variant='body1' color='onPrimary'>{t('special_condition')}</Typo>
                        {walletContact && walletContact.balances ?<Typo variant='body1' color='onPrimary'>{props.currency}{businessCommerce.toFixed(2)}</Typo> : <CustomizedCircularProgress />}
                    </Grid>
                </Grid>
            </Grid>
            <Grid item className={classes.barcode}>
                <IconButton onClick={() => props.onShowBarcode()}>
                    <BarcodeScanIcon />
                </IconButton>
            </Grid>
        </Grid>
    )
}

function AccountBalance(props) {
    const { classes, t, accountBalance, currency } = props;
    var balance = accountBalance && accountBalance.balance ? accountBalance.balance : 0;
    let overdue_amout = accountBalance && accountBalance.overdue_amount ? accountBalance.overdue_amount : 0;
    console.log("accountBalance==", accountBalance);
    const contactInfo = getContacts();

    return (
        <Grid item xs={12} sm={12} md={12} lg={4} xl={4} container className={classes.card} >
            <Grid item container className={classNames(classes.cardContent, classes.cursor)}>
                <Grid xs={12} item  >
                    <Grid item xs={12}>
                        <Grid xs={12} item container className={classes.row1}>
                            <Grid xs={1} item container alignItems='center'>
                                <Grid className={classes.bg_icon}>
                                    <MyAccountIcon style={{ margin: 0 }} />
                                </Grid>
                            </Grid>

                            <Grid item xs={11} container alignItems='center'>
                                <Typo variant='h6' color='onPrimary'>{t('account_balance')}</Typo>
                            </Grid>
                        </Grid>
                        <Grid xs={12} item>
                            <Typo variant='h3' mg_top_xs color='onPrimary'>{currency}{balance.toFixed(2)}</Typo>
                        </Grid>

                    </Grid>
                    <Grid item xs={12} container alignItems='center' className={classes.account_number}>
                        <Grid item xs={6}>
                            <Typo variant="subtitle1" color="onPrimary">{t('contact_code')}</Typo>
                        </Grid>
                        <Grid item xs={6}>
                            <Typo variant="subtitle1" color="onPrimary">{contactInfo && contactInfo.code ? contactInfo.code : null}</Typo>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} container alignItems='center' className={classes.account_number}>
                        <Grid item xs={6}>
                            <Typo variant="subtitle1" color="onPrimary">{t('my_account_number')}</Typo>
                        </Grid>
                        <Grid item xs={6}>
                            <Typo variant="subtitle1" color="onPrimary">{accountBalance && accountBalance.number ? accountBalance.number : null} {accountBalance && accountBalance.currency_code ? "(" + accountBalance.currency_code + ")" : null}</Typo>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} container alignItems='center' className={classes.account_number}>
                        <Grid item xs={6} container alignItems='center'>
                            <Typo variant="subtitle1" color='onPrimary'>{t('overdue_amount')}</Typo>
                        </Grid>
                        <Grid item xs={6} container alignItems='center'>
                            <Typo variant="subtitle1" color="onPrimary">{currency}{overdue_amout.toFixed(2)}</Typo>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

function CofferCup(props) {
    const { classes } = props
    var percentage = props.percentage;
    var imageSoure = levelImages[0];
    var index = 0;
    if (percentage > 0) {
        for (var i = 1; i <= 10; i++) {
            if (percentage >= ((i - 1) * 10) && percentage < (i * 10)) {
                imageSoure = levelImages[i];
                index = i;
            }
        }
    }
    if (index == 0) {
        return (
            <Grid className={classes.cup}>
                <img style={{ width: 120, height: 120 }} src={imageSoure} />
            </Grid>)
    }
    return (
        <Grid className={classes.cup}>
            <img style={{ width: 130, height: 130 }} src={imageSoure} />
        </Grid>)
}


function ExploreMore(props) {
    const { classes, t, embedded_links } = props;
    //console.log('HomeView hasMore=', hasMore)
    //const OffersMap = Array.from(offers)
    return (
        <Grid item>
            <Typo mg_left_md variant='caption1' color='onPrimary'>{t('explorer_more')}</Typo>
            <Grid xs={12} item>
                <InfiniteScroll
                    dataLength={embedded_links.length} //This is important field to render the next data
                    // next={handleLoadMore}
                    // hasMore={hasMore}
                    loader={<h4>{""}</h4>}
                >
                    <Grid xs={12} item container className={classes.margin}>
                        {embedded_links.map((item, index) => (
                            <EmbeddedLinkItem key={index} item={item} classes={classes} />
                        ))}
                    </Grid>
                </InfiniteScroll>
            </Grid>
        </Grid>
    )
}

function EmbeddedLinkItem(props) {
    const { classes, item } = props;

    const onOpenLink = () => {
        if (item.url) {
            window.open(item.url, "_blank");
        }
    }

    const app_config_creatives = getAppCfg().creatives ? getAppCfg().creatives : null
    const creatives = item.creatives ? item.creatives : app_config_creatives

    const image = dataUtil.getImageByUsageTypePortal(creatives, usage_type.refer_friend);
    return (
        <Grid xs={12} sm={12} md={6} lg={4} xl={4} item container className={classes.card} onClick={onOpenLink}>
            <Grid xs={12} item className={classes.item}>
                <Grid item container xs={12} justify='center'>
                    {image ? <img src={image.url} className={classes.item_cover} /> : null}
                </Grid>
                <Grid xs={12} item className={classes.item_content}>
                    <Typo mg_top_md mg_left_md variant='h6' >{item.title}</Typo>
                </Grid>

            </Grid>
        </Grid>

    );
}

function Subscriptions(props) {
    const { classes, t, subscriptions, subscriptionsFilter, handleLoadMore, hasMore, showLoadMore, showLoading, onChangeTab, periods, periodSelected } = props;
    const listService = (subcriptions) => {
        return subcriptions.filter(sub => sub.classification != 'EXPENSES_SERVICE')
    }
    return (
        <Grid item>
            <Grid item xs={12} container alignItems='center'>
                <Typo mg_left_md variant='caption1' color='onPrimary'>{t('services_title')}</Typo>
                <Grid item style={{ marginLeft: 20 }}>
                    {periods && periods.length > 0 && periods.map((period, index) => {
                        console.log("periodSelected == period: ", periodSelected == period);
                        return (
                            <Box key={index}>
                                <ButtonCustom size='xs' color={periodSelected == period ? 'primary' : 'onPrimary'}
                                    fullWidth
                                    onClick={() => onChangeTab(period)}>
                                    {period == 1 ? t('monthly') : period + t('month_title')}
                                </ButtonCustom>
                            </Box>
                        );
                    })}
                </Grid>
            </Grid>
            {showLoading && <Grid xs={12} item container justify='center'>
                <CustomizedCircularProgress />
            </Grid>}
            <Grid xs={12} item>
                {/* {subscriptionsFilter && subscriptionsFilter[periodSelected] && subscriptionsFilter[periodSelected].length > 0 && 
                    <InfiniteScroll
                        dataLength={subscriptionsFilter[periodSelected].length} //This is important field to render the next data
                        next={handleLoadMore}
                        hasMore={hasMore}
                        loader={showLoadMore? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                        >
                        <Grid xs={12} item container className={classes.margin}>
                            {subscriptionsFilter[periodSelected].map((item, index) => (
                                <SubcriptionItem key={index} item = {item} t={t} currency={props.currency}/>
                            ))}
                        </Grid>
                    </InfiniteScroll>
                } */}
                {subscriptions && listService(subscriptions) && listService(subscriptions).length > 0 &&
                    <InfiniteScroll
                        dataLength={listService(subscriptions).length} //This is important field to render the next data
                        next={handleLoadMore}
                        hasMore={hasMore}
                        loader={showLoadMore ? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                    >
                        <Grid xs={12} item container className={classes.margin}>
                            {listService(subscriptions).map((item, index) => (
                                <SubcriptionItem key={index} item={item} t={t} currency={props.currency} />
                            ))}
                        </Grid>
                    </InfiniteScroll>
                }
            </Grid>
        </Grid>
    )
}
export default withStyles(styles)(withTranslation()(HomeView));